import { render } from "./Event.vue?vue&type=template&id=83a79692"
import script from "./Event.vue?vue&type=script&lang=js"
export * from "./Event.vue?vue&type=script&lang=js"
script.render = render

export default script